const DashboardActionTypes = {
    START_FETCH_DASHBOARDS: 'START_FETCH_DASHBOARDS',
    SUCCESS_FETCH_DASHBOARDS: 'SUCCESS_FETCH_DASHBOARDS',
}

export default DashboardActionTypes
